import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-doc-ofertas-detalle',
  templateUrl: './doc-ofertas-detalle.component.html',
  styleUrls: ['./doc-ofertas-detalle.component.css']
})
export class DocOfertasDetalleComponent implements OnInit{
  idOferta : number;

  constructor(private _route: ActivatedRoute){}
              
  ngOnInit() {
    this._route.queryParams.subscribe((params) => {
      if (params.idOferta) {
        this.idOferta = JSON.parse(params.idOferta);
      }
    });
  }

}
